import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { Client } from '../../api/api-reference';
import { AuthService } from '../../services/auth.service';
import { jwtDecode } from 'jwt-decode';

@Component({
  selector: 'app-process-login',
  templateUrl: './process-login.component.html',
  styleUrls: ['./process-login.component.scss'],
})
export class ProcessLoginComponent implements OnInit {
  constructor(
    private activeRouter: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private toastr: ToastrService,
    private client: Client,
  ) { }

  getPermissions(): void {
    if (this.authService.isBpsAdmin()) {
      this.router.navigate(['/utilities/all']);
    }
    else {
      this.client.getMyPermissions().subscribe({
        next: (result) => {
          localStorage.setItem('permissions', result);
          window.location.href = '/';
        },
        error: (err) => {
          this.toastr.error(err)
          this.authService.logout();
        },
      });
    }
  }
  ngOnInit(): void {
    const accessToken = this.activeRouter.snapshot.queryParamMap.get('access_token');
    const messsage = this.activeRouter.snapshot.queryParamMap.get('message');

    if (accessToken && accessToken != '') {
      localStorage.setItem('token', accessToken);
      const tz = (jwtDecode(accessToken) as { timeZone: string }).timeZone;
      localStorage.setItem('tz', tz);
      this.getPermissions();
      return;
    }
    if (!accessToken || accessToken == '') {
      this.toastr.error(messsage!);
      this.router.navigate([''])
    }
  }
}
